import { mdiDotsVertical } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@mui/material';

import {
    ListItem,
    ListItemMedia,
    ListItemSecondaryAction,
    ListItemText,
} from 'common/components/ListItem';
import { IReceivedCertificateFragment } from 'graphql/types';
import { formatDate } from 'common/utils/formatDate';
import { Chip } from 'common/components/Chip';
import { DropdownMenu } from 'common/components/DropdownMenu';
import { IconButton } from 'common/components/IconButton';

interface IProps {
    receivedCertificate: IReceivedCertificateFragment;
}

export const ReceivedCertificateListItem = ({
    receivedCertificate,
}: IProps) => {
    const [translate] = useTranslation();

    const { title, thumbnail, date, expiryDate, isExpired, file } =
        receivedCertificate || {};

    const startDate = formatDate(date, 'dd MMMM yyyy');
    const endDate = expiryDate ? formatDate(expiryDate, 'dd MMMM yyyy') : '';
    const dateDisplay = `${startDate} ${endDate ? `- ${endDate}` : ''}`;

    return (
        <ListItem px={0}>
            <ListItemMedia
                color="primary"
                image={thumbnail?.url || ''}
                size="small"
            />

            <ListItemText primary={title} secondary={dateDisplay} />

            {!!file?.url && (
                <ListItemSecondaryAction>
                    <DropdownMenu
                        anchor={
                            <IconButton
                                color="inherit"
                                iconPath={mdiDotsVertical}
                                iconSize="2.4rem"
                                sx={{ mr: 2 }}
                            />
                        }
                    >
                        <MenuItem
                            onClick={() => {
                                file?.url && window.open(file.url, '_blank');
                            }}
                        >
                            {translate('download')}
                        </MenuItem>
                    </DropdownMenu>
                </ListItemSecondaryAction>
            )}

            <Chip bgColor={isExpired ? 'error' : 'success'} />
        </ListItem>
    );
};
